
<button type="button" style="text-align: center!important;" class="btn btn-default mat-icon-button "
    matTooltip="{{ workId }}" matTooltipClass="red-tooltip" (click)="copyWorkIdToClipBoard()">
    <b>{{currentValue}}</b>
</button>
